import React from 'react';
import { EventCodelessIcon } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './emptyContent.module.scss';

export const EmptyContent = () => {
    return (
        <div className={styles['container']}>
            <EventCodelessIcon />
            <div className={styles['text-container']}>
                <FormattedMessage
                    id="pixel.tester.empty.events.content.title"
                    defaultMessage="No Events Received"
                    className={styles['title']}
                />
                <FormattedMessage
                    id="pixel.tester.empty.events.content.description"
                    defaultMessage="Interact with your website to trigger events"
                    className={styles['description']}
                />
            </div>
        </div>
    );
};
